import { createContext } from "react";

const MobilePaidsContext = createContext({});

export default MobilePaidsContext;
